<app-header></app-header>

<section id="pills" class="bg-grey reset-section-pad2" *ngIf="isDataLoaded">

    <div class="container">

        <div class="row">
            <p class="fw-bold rco mb-2">#retalk</p>
            <app-title-section [titleTxt]="pillStaticData.titleTxt"></app-title-section>
            <div class="col-lg-8 mt-lg-5 mt-md-0">

                <p class="fw-bold" [innerHTML]="pillStaticData.subtitleText"></p>
                <p [innerHTML]="pillStaticData.mainText"></p>
            </div>
        </div>



        <div class="row">
            <div class="col-lg-12 col-md-12 retalk-blq mt-4 px-0">

                <app-pill-listing-block *ngFor="let item of pillData | reverse; index as i"
                    [pillBlock_item]="pillData[i]"></app-pill-listing-block>




            </div>
        </div>





    </div>


</section>


<app-footer-main></app-footer-main>